import { defineStore } from 'pinia';
import { useEntityStore } from '../../common/composables/entityStore';
import type { ProductionOrder } from '../domain/productionOrder';

export const useProductionOrderStore = defineStore('productionOrders', () => {
  const { add, remove, merge, getById, getOrThrow, clear, list, changed } =
    useEntityStore<ProductionOrder>({
      eventName: 'production-order-changed',
      getEntityId: (e) => e.id,
      updateEntity(dest, src) {
        dest.name = src.name;
        dest.state = src.state;
        dest.resource = src.resource;
        dest.priority = src.priority;
        dest.plannedStartUtc = src.plannedStartUtc;
        dest.plannedEndUtc = src.plannedEndUtc;
        dest.actualStartUtc = src.actualStartUtc;
        dest.actualEndUtc = src.actualEndUtc;
        dest.activeIntake = src.activeIntake;
        dest.activeProduction = src.activeProduction;
        dest.productionInstruction = src.productionInstruction;
        dest.vehicleInstruction = src.vehicleInstruction;
        dest.recipes = src.recipes;
      },
    });

  return {
    getById,
    add,
    remove,
    merge,
    getOrThrow,
    clear,
    productionOrders: list.value,
    changed,
  };
});
